module.exports = __webpack_public_path__ + "static/media/fernando.a97f2f9d.jpeg";